import Image from 'next/image';
import React from 'react';
import { ButtonClose } from '@ui';

interface ImageUploaderThumbnailProps {
  file: File;
  url: string;
  onRemove: () => void;
}

const ImageUploaderThumbnail: React.FC<ImageUploaderThumbnailProps> = ({ file, url, onRemove }) => (
  <div className='thumb'>
    <Image src={url} alt={file.name} className='thumb-img' width={200} height={200} />
    <ButtonClose className='btn-xs remove' type='button' onClick={onRemove} />
    <div className='meta'>
      <b className='truncate'>{file.name}</b>
      <small>({(file.size / (1024 * 1024)).toFixed(2)} MB)</small>
    </div>
  </div>
);

export default ImageUploaderThumbnail;
